module.exports = {"421123100":"凤山镇","421123101":"骆驼坳镇","421123102":"大河岸镇","421123103":"九资河镇","421123104":"胜利镇","421123105":"河铺镇","421123106":"三里畈镇","421123107":"匡河镇","421123108":"白庙河镇","421123109":"大崎镇","421123200":"白莲河乡","421123203":"平湖乡","421123400":"罗田县经济开发区","421123500":"青苔关林场","421123501":"天堂寨林场","421123502":"薄刀峰林场","421123503":"黄狮寨林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421123.json
// module id = 1899
// module chunks = 0